import { useGetNotificationsLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

export const useGetNotifications = () => {
  const [query, { data, refetch, loading }] = useGetNotificationsLazyQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    notifyOnNetworkStatusChange: true,
  });

  if (loading) {
    return undefined;
  }

  return {
    data,
    query,
    refetch,
  };
};
